<template>
    <div class="row">
        <div class="col-12 mb-1">
            <v-file-uploader :accept="['xlsx']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
        <div class="col-12 mb-1" v-if="(uploadErrors || []).length">
            <h5>Yükleme Hataları</h5>
            <ul class="list-group">
                <li class="list-group-item px-50 py-25 text-danger" v-for="(e,i) in uploadErrors" :key="i">
                    {{ e }}
                </li>
            </ul>
        </div>
        <div class="col-md-12 text-right">
            <button class="btn btn-sm btn-flat-success" v-on:click="getSample">
                <feather-icon icon="FileIcon"></feather-icon>
                Örnek Excel
            </button>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object,
        uploadErrors:Array
    },
    methods:{
        getSample(){
            EmployeeOperationsApi.Bes.GetSampleExcel().then(res=>{
                Additional.DownloadFile(res.data, 'BES.xlsx')
            })
        }
    },
}
</script>

<style>

</style>